import { AppointmentFormik, dlvApptApiFieldMapping, pickupApptApiFieldMapping } from '@/Forms/Appointment/types';
import { AssignedDriver } from '@forms/Driver/types';

export interface ManagePickupDeliveryProps {
	legId: number;
}

export type ManagePickupDeliveryFormik = Record<string, boolean | AppointmentFormik | AssignedDriver | null> & {
	pickupForm: AppointmentFormik;
	deliveryForm: AppointmentFormik;
	assignedDriver: AssignedDriver | null;
	requiresReminder: boolean;
};

export const managePudlApiFieldMappings: Record<keyof ManagePickupDeliveryFormik, string | Record<string, string>> = {
	// Sub-forms of the PuDl Formik, that use their own mappings
	pickupForm: pickupApptApiFieldMapping,
	deliveryForm: dlvApptApiFieldMapping,
	assignedDriver: 'drvId'
};
